










import { apiMerchantStoreGetWroteOffStoreList } from '@/api'
import { BookComponents } from '../components'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '适用商户',
        }))
      }

      query = useQuery<{
        // 商户 ID
        id: string
      }>()

      apiData = useApiPlus({
        storeData: () =>
          apiMerchantStoreGetWroteOffStoreList({ id: this.query.id }),
      })

      storeData = computed(() => this.apiData.data.storeData)

      loading = computed(() => this.apiData.loading)
    },
)
